import { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";

const API = "";  // пустая строка = тот же домен

const api = axios.create({ baseURL: API });
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem("token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

const STATUS_META = {
  unassigned:     { label: "Нераспределена",  color: "#f59e0b", bg: "#f59e0b18" },
  in_work:        { label: "В работе",         color: "#2563eb", bg: "#2563eb12" },
  awaiting_parts: { label: "Ожидаем запчасти", color: "#7c3aed", bg: "#7c3aed12" },
  closed:         { label: "Закрыта",          color: "#6b7280", bg: "#6b728014" },
};

const H_COLORS = {
  created: "#9ca3af", assign: "#2563eb", "status-change": "#ef4444",
  comment: "#f59e0b", photo: "#7c3aed", parts: "#10b981",
};

const fmt = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("ru-RU", { day: "2-digit", month: "2-digit", year: "2-digit" })
    + " " + d.toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });
};

// ── CSS ───────────────────────────────────────────────────────────────────────
const css = `
*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
html, body { height: 100%; }
:root {
  --bg: #f5f5f7; --surface: #fff; --border: #e5e7eb; --border2: #d1d5db;
  --text: #111827; --muted: #6b7280; --muted2: #9ca3af;
  --red: #ef4444; --red-bg: #fef2f2;
  --blue: #2563eb; --blue-bg: #eff6ff;
  --radius: 10px;
}
body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif; background: var(--bg); color: var(--text); }
::-webkit-scrollbar { width: 4px; } ::-webkit-scrollbar-track { background: transparent; } ::-webkit-scrollbar-thumb { background: var(--border2); border-radius: 4px; }
.app { min-height: 100vh; display: flex; flex-direction: column; }

/* login */
.login-screen { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; background: var(--bg); }
.login-box { background: var(--surface); border: 1.5px solid var(--border); border-radius: 14px; padding: 32px 28px; width: 100%; max-width: 360px; }
.login-logo { font-size: 20px; font-weight: 700; letter-spacing: -0.5px; margin-bottom: 4px; }
.login-logo .dot { color: var(--red); }
.login-sub { font-size: 13px; color: var(--muted); margin-bottom: 24px; }
.login-error { background: var(--red-bg); color: var(--red); font-size: 13px; padding: 8px 12px; border-radius: 7px; margin-bottom: 14px; }

/* topbar */
.topbar { background: var(--surface); border-bottom: 1px solid var(--border); min-height: 50px; padding: 8px 12px; display: flex; align-items: center; gap: 8px; position: sticky; top: 0; z-index: 100; flex-wrap: nowrap; overflow: hidden; }
.topbar-logo { font-size: 14px; font-weight: 700; letter-spacing: -0.3px; white-space: nowrap; flex-shrink: 0; }
.topbar-logo .dot { color: var(--red); }
.topbar-role { font-size: 10px; font-weight: 600; color: var(--blue); background: var(--blue-bg); padding: 3px 7px; border-radius: 5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 140px; }
.topbar-right { margin-left: auto; flex-shrink: 0; }
.topbar-switch { font-size: 12px; color: var(--muted); background: none; border: none; cursor: pointer; padding: 6px 8px; border-radius: 6px; transition: all 0.15s; font-family: inherit; white-space: nowrap; }
.topbar-switch:hover { background: var(--bg); color: var(--text); }

/* nav tabs */
.nav-tabs { background: var(--surface); border-bottom: 1px solid var(--border); display: flex; overflow-x: auto; padding: 0 12px; -webkit-overflow-scrolling: touch; flex-shrink: 0; }
.nav-tabs::-webkit-scrollbar { height: 0; }
.nav-tab { flex-shrink: 0; padding: 11px 13px; font-size: 13px; font-weight: 500; color: var(--muted); border: none; background: none; cursor: pointer; border-bottom: 2px solid transparent; transition: all 0.15s; display: flex; align-items: center; gap: 5px; font-family: inherit; white-space: nowrap; }
.nav-tab:hover { color: var(--text); }
.nav-tab.active { color: var(--blue); border-bottom-color: var(--blue); }
.nav-count { font-size: 10px; font-weight: 700; padding: 1px 5px; border-radius: 9px; min-width: 17px; text-align: center; }
.nav-count.red { background: var(--red); color: #fff; }
.nav-count.blue { background: var(--blue); color: #fff; }
.nav-count.muted { background: var(--border2); color: var(--muted); }

/* filter bar */
.filter-bar { background: var(--surface); border-bottom: 1px solid var(--border); padding: 10px 16px; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.search-wrap { position: relative; flex: 1; min-width: 160px; }
.search-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: var(--muted2); font-size: 13px; pointer-events: none; }
.search-input { width: 100%; background: var(--bg); border: 1.5px solid var(--border); border-radius: 8px; padding: 7px 10px 7px 30px; font-size: 13px; font-family: inherit; outline: none; transition: border 0.15s; color: var(--text); }
.search-input:focus { border-color: var(--blue); background: #fff; }
.search-input::placeholder { color: var(--muted2); }
.search-clear { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: none; border: none; color: var(--muted2); cursor: pointer; font-size: 14px; line-height: 1; padding: 2px; }
.filter-select { background: var(--bg); border: 1.5px solid var(--border); border-radius: 8px; padding: 7px 10px; font-size: 12px; font-family: inherit; color: var(--text); outline: none; cursor: pointer; transition: border 0.15s; flex-shrink: 0; }
.filter-select:focus { border-color: var(--blue); }
.filter-results { font-size: 12px; color: var(--muted); white-space: nowrap; }

/* content */
.content { flex: 1; padding: 14px 16px; max-width: 720px; margin: 0 auto; width: 100%; }
.page-hdr { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; gap: 8px; }
.page-hdr-title { font-size: 16px; font-weight: 700; }

/* buttons */
.btn { display: inline-flex; align-items: center; gap: 5px; padding: 8px 14px; border-radius: 8px; font-size: 13px; font-weight: 600; cursor: pointer; border: none; transition: all 0.15s; font-family: inherit; white-space: nowrap; }
.btn-primary { background: var(--blue); color: #fff; }
.btn-primary:hover { background: #1d4ed8; }
.btn-primary:disabled { opacity: 0.45; cursor: not-allowed; }
.btn-outline { background: var(--surface); color: var(--text); border: 1.5px solid var(--border2); }
.btn-outline:hover { border-color: var(--blue); color: var(--blue); }
.btn-red { background: var(--red); color: #fff; }
.btn-red:hover { background: #dc2626; }
.btn-ghost { background: none; color: var(--muted); border: 1.5px solid var(--border); }
.btn-ghost:hover { color: var(--text); border-color: var(--border2); }
.btn-green { background: #10b981; color: #fff; }
.btn-green:hover { background: #059669; }
.btn-sm { padding: 5px 10px; font-size: 12px; }

/* empty / loading */
.empty { text-align: center; padding: 56px 20px; color: var(--muted); }
.empty-icon { font-size: 36px; margin-bottom: 10px; opacity: 0.3; }
.empty-text { font-size: 13px; }

/* ticket list */
.ticket-list { display: flex; flex-direction: column; gap: 7px; }
.ticket-card { background: var(--surface); border: 1.5px solid var(--border); border-radius: var(--radius); padding: 12px 14px; cursor: pointer; transition: all 0.15s; }
.ticket-card:hover { border-color: var(--blue); box-shadow: 0 2px 10px rgba(37,99,235,0.07); }
.ticket-card.transferred { border-left: 3px solid #f59e0b; }
.tc-top { display: flex; align-items: flex-start; gap: 8px; margin-bottom: 7px; flex-wrap: wrap; }
.tc-id { font-size: 11px; color: var(--muted2); font-weight: 500; flex-shrink: 0; margin-top: 2px; }
.tc-text { font-size: 13px; font-weight: 500; flex: 1; min-width: 120px; line-height: 1.4; color: var(--text); word-break: break-word; }
.tc-badges { display: flex; gap: 5px; flex-shrink: 0; flex-wrap: wrap; justify-content: flex-end; max-width: 100%; }
.badge { font-size: 11px; font-weight: 600; padding: 2px 7px; border-radius: 5px; white-space: nowrap; }
.badge-transfer { background: #fff7ed; color: #c2410c; border: 1px solid #fed7aa; }
.tc-meta { display: flex; flex-wrap: wrap; gap: 10px; font-size: 11px; color: var(--muted); }
.tc-meta-item { display: flex; align-items: center; gap: 3px; }

/* modal */
.overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.4); z-index: 200; display: flex; align-items: flex-end; justify-content: center; padding: 0; }
@media (min-width: 600px) { .overlay { align-items: center; padding: 20px; } }
.modal { background: var(--surface); border-radius: 16px 16px 0 0; width: 100%; max-width: 580px; max-height: 92vh; overflow-y: auto; padding: 18px 18px 28px; position: relative; }
@media (min-width: 600px) { .modal { border-radius: 14px; max-height: 88vh; } }
.modal-handle { width: 34px; height: 4px; background: var(--border2); border-radius: 2px; margin: 0 auto 14px; }
@media (min-width: 600px) { .modal-handle { display: none; } }
.modal-close { position: absolute; top: 14px; right: 14px; background: var(--bg); border: none; color: var(--muted); width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 13px; transition: all 0.15s; }
.modal-close:hover { background: var(--border); color: var(--text); }
.modal-title { font-size: 16px; font-weight: 700; margin-bottom: 14px; }

/* form */
.form-group { margin-bottom: 12px; }
.form-label { display: block; font-size: 11px; font-weight: 600; color: var(--muted); margin-bottom: 5px; text-transform: uppercase; letter-spacing: 0.4px; }
.form-input, .form-select, .form-textarea { width: 100%; background: var(--bg); border: 1.5px solid var(--border); color: var(--text); border-radius: 8px; padding: 9px 12px; font-size: 13px; font-family: inherit; outline: none; transition: border 0.15s; }
.form-input:focus, .form-select:focus, .form-textarea:focus { border-color: var(--blue); background: #fff; }
.form-textarea { resize: vertical; min-height: 100px; line-height: 1.5; }
.form-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 18px; }

/* divider */
.divider { border: none; border-top: 1px solid var(--border); margin: 14px 0; }

/* detail */
.kv-row { display: flex; gap: 6px; margin-bottom: 6px; font-size: 12px; }
.kv-row label { color: var(--muted); flex-shrink: 0; min-width: 70px; }
.kv-row value { color: var(--text); font-weight: 500; }
.desc-box { background: var(--bg); border-radius: 8px; padding: 12px; font-size: 13px; line-height: 1.55; margin-bottom: 12px; white-space: pre-wrap; word-break: break-word; }

/* history */
.sec-label { font-size: 10px; font-weight: 700; color: var(--muted); text-transform: uppercase; letter-spacing: 0.7px; margin-bottom: 8px; }
.history { display: flex; flex-direction: column; gap: 5px; }
.h-item { display: flex; gap: 8px; align-items: flex-start; font-size: 12px; padding: 7px 10px; border-radius: 7px; background: var(--bg); }
.h-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; margin-top: 3px; }
.h-text { flex: 1; color: var(--text); line-height: 1.4; }
.h-time { font-size: 11px; color: var(--muted2); white-space: nowrap; }

/* photos */
.photo-grid { display: flex; flex-wrap: wrap; gap: 7px; margin-top: 7px; }
.photo-thumb { width: 72px; height: 72px; object-fit: cover; border-radius: 7px; cursor: zoom-in; border: 1.5px solid var(--border); transition: border-color 0.15s; }
.photo-thumb:hover { border-color: var(--blue); }

/* upload */
.upload-zone { border: 1.5px dashed var(--border2); border-radius: 8px; padding: 14px; text-align: center; cursor: pointer; transition: all 0.15s; color: var(--muted); font-size: 13px; }
.upload-zone:hover { border-color: var(--blue); color: var(--blue); background: var(--blue-bg); }
.upload-zone input { display: none; }

/* action panel */
.action-panel { background: var(--bg); border: 1.5px solid var(--border); border-radius: var(--radius); padding: 12px; margin-top: 12px; }
.action-panel-label { font-size: 10px; font-weight: 700; color: var(--blue); text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 10px; }
.action-btns { display: flex; flex-wrap: wrap; gap: 7px; }
.assign-row { display: flex; gap: 7px; align-items: center; }
.assign-row .form-select { flex: 1; }

/* lightbox */
.lightbox { position: fixed; inset: 0; background: rgba(0,0,0,0.9); z-index: 400; display: flex; align-items: center; justify-content: center; cursor: zoom-out; padding: 20px; }
.lightbox img { max-width: 100%; max-height: 100%; border-radius: 8px; object-fit: contain; }

mark { background: #fef08a; color: inherit; border-radius: 2px; padding: 0 1px; }
`;

function Highlight({ text, query }) {
  if (!query || !text) return <>{text}</>;
  const idx = text.toLowerCase().indexOf(query.toLowerCase());
  if (idx === -1) return <>{text}</>;
  return <>{text.slice(0, idx)}<mark>{text.slice(idx, idx + query.length)}</mark>{text.slice(idx + query.length)}</>;
}

// ── App ───────────────────────────────────────────────────────────────────────
export default function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
  });
  const [tickets, setTickets] = useState([]);
  const [mechanics, setMechanics] = useState([]);
  const [tab, setTab] = useState("unassigned");
  const [modal, setModal] = useState(null);
  const [sel, setSel] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filterMechanic, setFilterMechanic] = useState("all");

  const loadTickets = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const { data } = await api.get("/api/tickets");
      setTickets(data);
    } catch (e) {
      if (e.response?.status === 401) logout();
    } finally { setLoading(false); }
  }, [user]);

  useEffect(() => {
    if (user) {
      loadTickets();
      if (user.role === "admin") {
        api.get("/api/mechanics").then(r => setMechanics(r.data));
      }
      // Auto-refresh every 30 seconds
      const interval = setInterval(loadTickets, 30000);
      return () => clearInterval(interval);
    }
  }, [user, loadTickets]);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setTickets([]);
  };

  const onLogin = (u) => {
    setUser(u);
    setTab(u.role === "parts" ? "parts" : u.role === "admin" ? "unassigned" : "active");
  };

  // tabs
  const tabsForRole = () => {
    if (!user) return [];
    if (user.role === "admin") return [
      { id: "unassigned", label: "Нераспределённые", accent: "red",
        count: tickets.filter(t => t.status === "unassigned").length },
      { id: "active",  label: "В работе",  accent: "blue",
        count: tickets.filter(t => t.status === "in_work").length },
      { id: "parts",   label: "Запчасти",  accent: "blue",
        count: tickets.filter(t => t.status === "awaiting_parts").length },
      { id: "closed",  label: "Закрытые заявки", accent: "muted",
        count: tickets.filter(t => t.status === "closed").length },
      { id: "all",     label: "Все", accent: "muted", count: tickets.length },
    ];
    if (user.role === "mechanic") return [
      { id: "active", label: "Мои заявки", accent: "blue",
        count: tickets.filter(t => t.status === "in_work").length },
      { id: "parts",  label: "Ожидаем запчасти", accent: "blue",
        count: tickets.filter(t => t.status === "awaiting_parts").length },
    ];
    return [{ id: "parts", label: "Ожидаем запчасти", accent: "blue",
      count: tickets.filter(t => t.status === "awaiting_parts").length }];
  };

  const baseList = () => {
    if (user?.role === "admin") {
      if (tab === "unassigned") return tickets.filter(t => t.status === "unassigned");
      if (tab === "active")     return tickets.filter(t => t.status === "in_work");
      if (tab === "parts")      return tickets.filter(t => t.status === "awaiting_parts");
      if (tab === "closed")     return tickets.filter(t => t.status === "closed");
      return tickets;
    }
    if (user?.role === "mechanic") {
      if (tab === "active") return tickets.filter(t => t.status === "in_work");
      return tickets.filter(t => t.status === "awaiting_parts");
    }
    return tickets.filter(t => t.status === "awaiting_parts");
  };

  const filteredList = () => {
    let list = baseList();
    if (filterMechanic !== "all") list = list.filter(t => String(t.assigned_to) === filterMechanic);
    if (search.trim()) {
      const q = search.trim().toLowerCase();
      list = list.filter(t =>
        `#${t.id}`.includes(q) ||
        (t.text || "").toLowerCase().includes(q) ||
        (t.assigned_name || "").toLowerCase().includes(q)
      );
    }
    return list;
  };

  // actions
  const createTicket = async (text) => {
    await api.post("/api/tickets", { text });
    setModal(null);
    loadTickets();
  };

  const assignTicket = async (id, mechanic_id) => {
    await api.patch(`/api/tickets/${id}/assign`, { mechanic_id });
    loadTickets();
  };

  const mechanicAction = async (id, action, comment, files) => {
    await api.patch(`/api/tickets/${id}/action`, { action, comment });
    if (files?.length) {
      const fd = new FormData();
      files.forEach(f => fd.append("photos", f));
      await api.post(`/api/tickets/${id}/photos`, fd);
    }
    loadTickets();
  };

  const partsReady = async (id) => {
    await api.patch(`/api/tickets/${id}/parts-ready`);
    loadTickets();
  };

  if (!user) return (
    <>
      <style>{css}</style>
      <LoginScreen onLogin={onLogin} />
    </>
  );

  const tabs = tabsForRole();
  const list = filteredList();
  const showMechanicFilter = user.role === "admin" && (tab === "active" || tab === "all" || tab === "closed");
  const roleLabel = user.role === "admin" ? "Администратор"
    : user.role === "parts" ? "Менеджер запчастей"
    : `Механик · ${user.name?.split(" ")[1] || user.name}`;

  return (
    <>
      <style>{css}</style>
      <div className="app">
        <div className="topbar">
          <div className="topbar-logo">Сервис<span className="dot">.</span>Контроль</div>
          <div className="topbar-role">{roleLabel}</div>
          <div className="topbar-right">
            <button className="topbar-switch" onClick={logout}>Выйти ↗</button>
          </div>
        </div>

        <div className="nav-tabs">
          {tabs.map(t => (
            <button key={t.id} className={`nav-tab ${tab === t.id ? "active" : ""}`}
              onClick={() => { setTab(t.id); setSearch(""); setFilterMechanic("all"); }}>
              {t.label}
              {t.count > 0 && <span className={`nav-count ${t.accent}`}>{t.count}</span>}
            </button>
          ))}
        </div>

        <div className="filter-bar">
          <div className="search-wrap">
            <span className="search-icon">🔍</span>
            <input className="search-input" placeholder="Поиск по тексту, номеру, механику..."
              value={search} onChange={e => setSearch(e.target.value)} />
            {search && <button className="search-clear" onClick={() => setSearch("")}>✕</button>}
          </div>
          {showMechanicFilter && (
            <select className="filter-select" value={filterMechanic} onChange={e => setFilterMechanic(e.target.value)}>
              <option value="all">Все механики</option>
              {mechanics.map(m => <option key={m.id} value={String(m.id)}>{m.name}</option>)}
            </select>
          )}
          {(search || filterMechanic !== "all") && (
            <span className="filter-results">{list.length} зап.</span>
          )}
        </div>

        <div className="content">
          <div className="page-hdr">
            <div className="page-hdr-title">{tabs.find(t => t.id === tab)?.label}</div>
            {user.role === "admin" && (
              <button className="btn btn-primary btn-sm" onClick={() => setModal("create")}>+ Заявка</button>
            )}
          </div>

          {loading ? (
            <div className="empty"><div className="empty-icon">⏳</div><div className="empty-text">Загрузка...</div></div>
          ) : list.length === 0 ? (
            <div className="empty">
              <div className="empty-icon">{search ? "🔍" : "📭"}</div>
              <div className="empty-text">{search ? "Ничего не найдено" : "Заявок нет"}</div>
            </div>
          ) : (
            <div className="ticket-list">
              {list.map(t => (
                <TicketCard key={t.id} ticket={t} search={search}
                  onClick={() => { setSel(t); setModal("detail"); }} />
              ))}
            </div>
          )}
        </div>

        {modal === "create" && <CreateModal onClose={() => setModal(null)} onCreate={createTicket} />}
        {modal === "detail" && sel && (
          <DetailModal
            ticket={tickets.find(t => t.id === sel.id) || sel}
            user={user}
            mechanics={mechanics}
            onClose={() => { setModal(null); setSel(null); }}
            onAssign={assignTicket}
            onMechanicAction={mechanicAction}
            onPartsReady={partsReady}
            onRefresh={loadTickets}
            onLightbox={src => setLightbox(src)}
          />
        )}
        {lightbox && (
          <div className="lightbox" onClick={() => setLightbox(null)}>
            <img src={lightbox} alt="" />
          </div>
        )}
      </div>
    </>
  );
}

// ── Login ─────────────────────────────────────────────────────────────────────
function LoginScreen({ onLogin }) {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!login || !password) return;
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/api/login", { login, password });
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      onLogin(data.user);
    } catch (e) {
      setError(e.response?.data?.error || "Ошибка входа");
    } finally { setLoading(false); }
  };

  return (
    <div className="login-screen">
      <div className="login-box">
        <div className="login-logo">Сервис<span className="dot">.</span>Контроль</div>
        <div className="login-sub">Управление заявками на ремонт оборудования</div>
        {error && <div className="login-error">{error}</div>}
        <div className="form-group">
          <label className="form-label">Логин</label>
          <input className="form-input" value={login} onChange={e => setLogin(e.target.value)}
            placeholder="admin" onKeyDown={e => e.key === "Enter" && submit()} />
        </div>
        <div className="form-group">
          <label className="form-label">Пароль</label>
          <input className="form-input" type="password" value={password}
            onChange={e => setPassword(e.target.value)} placeholder="••••••••"
            onKeyDown={e => e.key === "Enter" && submit()} />
        </div>
        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center" }}
          disabled={loading || !login || !password} onClick={submit}>
          {loading ? "Вход..." : "Войти"}
        </button>
        <div style={{ marginTop: 16, fontSize: 11, color: "var(--muted)", lineHeight: 1.6 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Тестовые аккаунты:</div>
          admin / admin123<br />
          petrov / petrov123<br />
          kozlov / kozlov123<br />
          parts / parts123
        </div>
      </div>
    </div>
  );
}

// ── Ticket Card ───────────────────────────────────────────────────────────────
function TicketCard({ ticket, search, onClick }) {
  const sm = STATUS_META[ticket.status] || STATUS_META.unassigned;
  const isTransfer = ticket.transferred && ticket.status === "unassigned";
  const preview = (ticket.text || "").slice(0, 120) + ((ticket.text || "").length > 120 ? "…" : "");
  return (
    <div className={`ticket-card ${isTransfer ? "transferred" : ""}`} onClick={onClick}>
      <div className="tc-top">
        <span className="tc-id">#{ticket.id}</span>
        <span className="tc-text"><Highlight text={preview} query={search} /></span>
        <div className="tc-badges">
          {isTransfer && <span className="badge badge-transfer">Перенос</span>}
          <span className="badge" style={{ background: sm.bg, color: sm.color }}>{sm.label}</span>
        </div>
      </div>
      <div className="tc-meta">
        {ticket.assigned_name
          ? <span className="tc-meta-item">👷 <Highlight text={ticket.assigned_name} query={search} /></span>
          : <span className="tc-meta-item" style={{ color: "var(--muted2)" }}>Не назначен</span>}
        <span className="tc-meta-item">🕐 {fmt(ticket.created_at)}</span>
        {ticket.photos?.length > 0 && <span className="tc-meta-item">📷 {ticket.photos.length}</span>}
      </div>
    </div>
  );
}

// ── Create Modal ──────────────────────────────────────────────────────────────
function CreateModal({ onClose, onCreate }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const valid = text.trim().length > 0;

  const submit = async () => {
    if (!valid) return;
    setLoading(true);
    await onCreate(text.trim());
    setLoading(false);
  };

  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-handle" />
        <button className="modal-close" onClick={onClose}>✕</button>
        <div className="modal-title">Новая заявка</div>
        <div className="form-group">
          <label className="form-label">Текст заявки</label>
          <textarea className="form-textarea" style={{ minHeight: 140 }} value={text}
            onChange={e => setText(e.target.value)} autoFocus
            placeholder="Опишите задачу, адрес, оборудование, проблему..." />
        </div>
        <div className="form-actions">
          <button className="btn btn-ghost" onClick={onClose}>Отмена</button>
          <button className="btn btn-primary" disabled={!valid || loading} onClick={submit}>
            {loading ? "Создаём..." : "Создать"}
          </button>
        </div>
      </div>
    </div>
  );
}

// ── Detail Modal ──────────────────────────────────────────────────────────────
function DetailModal({ ticket, user, mechanics, onClose, onAssign, onMechanicAction, onPartsReady, onRefresh, onLightbox }) {
  const [assignTo, setAssignTo] = useState(ticket.assigned_to || mechanics[0]?.id || "");
  const [comment, setComment] = useState("");
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef();

  const sm = STATUS_META[ticket.status] || STATUS_META.unassigned;
  const isAdmin = user.role === "admin";
  const isMechanic = user.role === "mechanic";
  const isParts = user.role === "parts";

  const canAssign   = isAdmin && (ticket.status === "unassigned" || ticket.status === "in_work");
  const canMechanic = isMechanic && ticket.status === "in_work";
  const canParts    = isParts && ticket.status === "awaiting_parts";

  const handleFiles = (fileList) => {
    const arr = Array.from(fileList);
    setFiles(arr);
    setPreviews(arr.map(f => URL.createObjectURL(f)));
  };

  const doAction = async (action) => {
    setLoading(true);
    await onMechanicAction(ticket.id, action, comment, action === "parts" ? files : []);
    onClose();
  };

  const photoBaseUrl = window.location.origin;

  return (
    <div className="overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-handle" />
        <button className="modal-close" onClick={onClose}>✕</button>

        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
          <div className="modal-title" style={{ margin: 0 }}>Заявка #{ticket.id}</div>
          <span className="badge" style={{ background: sm.bg, color: sm.color }}>{sm.label}</span>
          {ticket.transferred && ticket.status === "unassigned" &&
            <span className="badge badge-transfer">Перенос</span>}
        </div>

        {ticket.assigned_name && (
          <div className="kv-row"><label>Механик</label><value>{ticket.assigned_name}</value></div>
        )}
        <div className="kv-row"><label>Создана</label><value>{fmt(ticket.created_at)}</value></div>

        <div className="desc-box" style={{ marginTop: 10 }}>{ticket.text || "—"}</div>

        {ticket.photos?.length > 0 && <>
          <div className="sec-label">📷 Фото</div>
          <div className="photo-grid">
            {ticket.photos.map((src, i) => (
              <img key={i} className="photo-thumb" src={`${photoBaseUrl}${src}`} alt=""
                onClick={() => onLightbox(`${photoBaseUrl}${src}`)} />
            ))}
          </div>
          <hr className="divider" />
        </>}

        {canAssign && (
          <div className="action-panel">
            <div className="action-panel-label">
              {ticket.status === "in_work" ? "Переназначить механика" : "Назначить механика"}
            </div>
            <div className="assign-row">
              <select className="form-select" value={assignTo} onChange={e => setAssignTo(e.target.value)}>
                {mechanics.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
              <button className="btn btn-primary btn-sm" onClick={async () => {
                await onAssign(ticket.id, assignTo); onClose();
              }}>
                {ticket.status === "in_work" ? "Переназначить" : "Назначить"}
              </button>
            </div>
          </div>
        )}

        {canMechanic && (
          <div className="action-panel">
            <div className="action-panel-label">Действия</div>
            <div className="form-group">
              <label className="form-label">Комментарий</label>
              <textarea className="form-textarea" style={{ minHeight: 52 }} value={comment}
                onChange={e => setComment(e.target.value)} placeholder="Необязательно..." />
            </div>
            <div className="form-group">
              <label className="form-label">Фото (для запчастей)</label>
              <div className="upload-zone" onClick={() => fileRef.current?.click()}>
                <input ref={fileRef} type="file" accept="image/*" multiple onChange={e => handleFiles(e.target.files)} />
                📎 Выбрать фото
              </div>
              {previews.length > 0 && (
                <div className="photo-grid" style={{ marginTop: 7 }}>
                  {previews.map((s, i) => <img key={i} className="photo-thumb" src={s} alt="" />)}
                </div>
              )}
            </div>
            <div className="action-btns">
              <button className="btn btn-outline btn-sm" disabled={loading} onClick={() => doAction("parts")}>
                📦 Ожидаем запчасти
              </button>
              <button className="btn btn-ghost btn-sm" disabled={loading} onClick={() => doAction("transfer")}>
                🔄 Перенести
              </button>
              <button className="btn btn-red btn-sm" disabled={loading} onClick={() => doAction("close")}>
                ✓ Закрыть
              </button>
            </div>
          </div>
        )}

        {canParts && (
          <div className="action-panel">
            <div className="action-panel-label">Менеджер запчастей</div>
            <button className="btn btn-green btn-sm" onClick={async () => {
              await onPartsReady(ticket.id); onClose();
            }}>
              ✓ Запчасти готовы
            </button>
          </div>
        )}

        <hr className="divider" />
        <div className="sec-label">История</div>
        <div className="history">
          {(ticket.history || []).slice().reverse().map((h, i) => (
            <div key={i} className="h-item">
              <div className="h-dot" style={{ background: H_COLORS[h.type] || "#9ca3af" }} />
              <div className="h-text">{h.text}</div>
              <div className="h-time">{fmt(h.at)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
